//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { TelephoneInformationInputItem } from './TelephoneInformationInputItem';
import { AdultInputItem } from './AdultInputItem';

export class ParentInputItem extends AdultInputItem {
    EmailAddress: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    Note: string | null = null;
    SendEmailReminders: boolean = false;
    SendSMSReminders: boolean = false;
    TelephoneMobile: TelephoneInformationInputItem | null = null;
    FamilyID: string | null = null;

    constructor(initializer?: Partial<ParentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "ParentInputItem";
}
